import * as React from "react";
import { forwardRef } from "react";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import { BLANK } from "views/components/contexts/SearchPageLayoutContext";
import SearchPageLayoutProvider from "views/components/contexts/SearchPageLayoutProvider";
import SearchPage from "views/pages/SearchPage";
import WidgetActionsContext from "views/components/contexts/WidgetActionsContext";
import replayLinkWidgetAction from "./ReplayLinkWidgetAction";
const WIDGET_ACTIONS = [replayLinkWidgetAction];
const SearchAreaContainer = forwardRef(({ children }, ref) => /* @__PURE__ */ React.createElement("div", { ref }, children));
const SEARCH_PAGE_LAYOUT_CONTEXT_VALUE = {
  sidebar: { isShown: false },
  viewActions: BLANK,
  searchAreaContainer: { component: SearchAreaContainer }
};
const WelcomeSearch = ({ view }) => /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: "read-only" }, /* @__PURE__ */ React.createElement(WidgetActionsContext.Provider, { value: WIDGET_ACTIONS }, /* @__PURE__ */ React.createElement(SearchPageLayoutProvider, { value: SEARCH_PAGE_LAYOUT_CONTEXT_VALUE }, /* @__PURE__ */ React.createElement(SearchPage, { view, isNew: false, skipNoStreamsCheck: true }))));
export default WelcomeSearch;
